import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-text-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldComponent implements AfterViewInit {
  formCtrl = input.required<FormControl>();
  suffix = input<string>();
  placeholder = input<string>();
  customStyles = input<{ [key: string]: string }>({});
  htmlInputElement = output<ElementRef<HTMLInputElement>>();

  readonly textFieldInputElement = viewChild.required<ElementRef<HTMLInputElement>>('textFieldInputElement');

  ngAfterViewInit(): void {
    this.htmlInputElement.emit(this.textFieldInputElement());
  }
}
